/* eslint-disable camelcase */
export default {
  you_are_logged_in: 'You are logged in!',
  password_changed: 'Password changed!',
  forgot_password: "Forgot your password?",
  login_button: "Login",
  unknown_error: "Unknown error occurred while trying to login",
};
